import { GETREQUESTOPTIONS, instance } from '../apiService';

export interface SyncRunSystem {
    systemId: string;
    name: string;
    versions: number[];
}

export interface SyncRunImplant {
    implantId: string;
    name: string;
    mriCode?: string;
}

export interface SyncRunManufacturer {
    manufacturerId: string;
    name: string;
    outcome: 'created' | 'replaced' | 'updatedInPlace' | 'conflict';
    detail?: string;
}

export interface SyncRunVerification {
    ok: boolean;
    failures: {
        kind: 'system' | 'manufacturer' | 'implant';
        id: string;
        name?: string;
        detail: string;
    }[];
}

export type SyncRunKind = 'sync' | 'revoke';
/** Which pipeline the run belongs to. Rows predating the field are 'active'. */
export type SyncRunDomain = 'active' | 'passive';

export interface SyncRun {
    /** Sender-generated id shared with the data pipeline's own history row. */
    syncRunId?: string;
    /** What the run did. Rows predating the field are reported as 'sync'. */
    kind: SyncRunKind;
    domain: SyncRunDomain;
    /** Passive runs arrive in batches; one row is recorded per batch. */
    batch?: { index: number; total: number };
    occurredAt: string;
    actorName: string;
    source?: string;
    status: 'ok' | 'error';
    error?: string;
    /** Follow-up problems on a stored run, e.g. a failed search reindex. */
    warnings: string[];
    systems: SyncRunSystem[];
    /** Implants covered by a passive run (empty on active runs). */
    implants: SyncRunImplant[];
    manufacturers: SyncRunManufacturer[];
    totals: {
        systems: number;
        versions: number;
        configs: number;
        files: number;
        manufacturers: number;
        implants?: number;
        conditionals?: number;
        histories?: number;
    };
    verification?: SyncRunVerification;
}

export const getSyncRuns = async (
    limit = 20,
    domain?: SyncRunDomain
): Promise<SyncRun[]> => {
    const response = await instance.get('/api/sync/runs', {
        ...GETREQUESTOPTIONS(),
        params: domain ? { limit, domain } : { limit },
    });
    return response.data.data;
};
